import { render, staticRenderFns } from "./InvoiceList_List.vue?vue&type=template&id=237f9163&"
import script from "./InvoiceList_List.vue?vue&type=script&lang=js&"
export * from "./InvoiceList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports